module.exports = __webpack_public_path__ + "assets/img/reserve.3d79ba7d.svg";